import { w as withConfigTransport } from "../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaSidebarItem } from "./VaSidebarItem-3745d5f3.mjs";
import { _ as _VaSidebarItemContent } from "./VaSidebarItemContent-434e1403.mjs";
import { _ as _VaSidebarItemTitle } from "./VaSidebarItemTitle-19558eeb.mjs";
const VaSidebarItemContent = withConfigTransport(_VaSidebarItemContent);
const VaSidebarItemTitle = withConfigTransport(_VaSidebarItemTitle);
const VaSidebarItem = withConfigTransport(_VaSidebarItem);
export {
  VaSidebarItem as V,
  VaSidebarItemContent as a,
  VaSidebarItemTitle as b
};
//# sourceMappingURL=index-e5686de2.mjs.map
